import * as React from "react";
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";
import "../../stylesheets/flatpickr.css";
// import "./style.css";

/* eslint-disable import/no-webpack-loader-syntax */
import AllTimeIcon from "-!svg-react-loader!../../images/icn-calendar.svg";
import TodayIcon from "-!svg-react-loader!../../images/icn-filter-calendar-today.svg";
import ThisWeekIcon from "-!svg-react-loader!../../images/icn-filter-calendar-this-week.svg";
import TwoWeeksIcon from "-!svg-react-loader!../../images/icn-filter-calendar-two-weeks.svg";
import ThisMonthIcon from "-!svg-react-loader!../../images/icn-filter-calendar-this-month.svg";
import СustomPeriodIcon from "-!svg-react-loader!../../images/icn-filter-calendar-custom.svg";
/* eslint-enable import/no-webpack-loader-syntax */

import Flatpickr from "react-flatpickr";
import { Modal } from "react-bootstrap";
import FilterRadioButton from './filter-button';
import { IRootState } from 'src/reducers';
import { TimePeriod, IReportFilters } from 'src/contracts/IReportFilters';
import { reportChangeFilterAction } from 'src/actions/wipereport.actions';

export const creationDateFilterMessages = defineMessages({
    allTime: {
        defaultMessage: "All time",
        id: "sidebar-filters.creationDate.allTime"
    },
    customPeriod: {
        defaultMessage: "Custom Period...",
        id: "sidebar-filters.creationDate.customPeriod"
    },
    thisMonth: {
        defaultMessage: "This Month",
        id: "sidebar-filters.creationDate.thisMonth"
    },
    thisWeek: {
        defaultMessage: "This Week",
        id: "sidebar-filters.creationDate.thisWeek"
    },
    title: {
        defaultMessage: "Creation date",
        id: "sidebar-filters.creationDate.title"
    },
    today: {
        defaultMessage: "Today",
        id: "sidebar-filters.creationDate.today"
    },
    twoWeeks: {
        defaultMessage: "Two Weeks",
        id: "sidebar-filters.creationDate.fortnight"
    },
});

export interface ICreationDateGroupProps extends InjectedIntlProps {
    selectedTag: TimePeriod;
    reportChangeFilterAction?: (filters: IReportFilters) => void;
}

export interface ICreationDateGroupState {
    isCustomDateModalShown: boolean;
    customRange: any;
}

class CreationDateGroup extends React.Component<ICreationDateGroupProps, ICreationDateGroupState>  {
    public state: ICreationDateGroupState = {
        customRange: [],
        isCustomDateModalShown: false,
    }
    constructor(props: ICreationDateGroupProps) {
        super(props)
    }


    public render() {
        return (
            <div className="sidebar__report-type-filter">
                <div className="sidebar__filter-title">
                    <FormattedMessage
                        id="sidebar-filters.creationDate.title"
                        defaultMessage={`Creation date`}
                    />
                </div>
                <div>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.allTime)}
                        checked={this.props.selectedTag === TimePeriod.AllTime}
                        tag={TimePeriod.AllTime}
                        onClick={this.handleButtonClick}>
                        <AllTimeIcon />
                    </FilterRadioButton>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.today)}
                        checked={this.props.selectedTag === TimePeriod.Today}
                        tag={TimePeriod.Today}
                        onClick={this.handleButtonClick}>
                        <TodayIcon />
                    </FilterRadioButton>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.thisWeek)}
                        checked={this.props.selectedTag === TimePeriod.ThisWeek}
                        tag={TimePeriod.ThisWeek}
                        onClick={this.handleButtonClick}>
                        <ThisWeekIcon />
                    </FilterRadioButton>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.twoWeeks)}
                        checked={this.props.selectedTag === TimePeriod.Fortnight}
                        tag={TimePeriod.Fortnight}
                        onClick={this.handleButtonClick}>
                        <TwoWeeksIcon />
                    </FilterRadioButton>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.thisMonth)}
                        checked={this.props.selectedTag === TimePeriod.ThisMonth}
                        tag={TimePeriod.ThisMonth}
                        onClick={this.handleButtonClick}>
                        <ThisMonthIcon />
                    </FilterRadioButton>
                    <FilterRadioButton
                        title={this.props.intl.formatMessage(creationDateFilterMessages.customPeriod)}
                        checked={this.props.selectedTag === TimePeriod.Custom}
                        tag={TimePeriod.Custom}
                        onClick={this.handleCustomDateClick}>
                        <СustomPeriodIcon />
                    </FilterRadioButton>
                </div>
                <Modal
                    className="custom-date-modal"
                    show={this.state.isCustomDateModalShown}
                    onHide={() => this.setState({ isCustomDateModalShown: false })}>
                    {/* <Modal.Header closeButton={true}>Choose date</Modal.Header> */}
                    <Modal.Body>
                        <Flatpickr
                            value={this.state.customRange}
                            onChange={this.handleDatePickerChange}
                            options={{
                                altFormat: "d.m.Y",
                                altInput: true,
                                inline: true,
                                mode: 'range',
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            onClick={this.handleChangeDatesClick}
                            className="btn btn-primary">
                            Change dates
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    private handleDatePickerChange = (range: Date[]) => {
        this.setState({ customRange: range })
        console.log(range);
    }

    private handleChangeDatesClick = () => {
        this.setState({ isCustomDateModalShown: false })
        console.log(this.state.customRange);

        const startDate = (this.state.customRange as Date[])[0]
        const endDate = (this.state.customRange as Date[])[1]
        this.props.reportChangeFilterAction!({ startDate, endDate, searchString: undefined, timePeriod: TimePeriod.Custom })
    }

    private handleCustomDateClick = (e: any) => {
        this.setState({ isCustomDateModalShown: true })
    }

    private handleButtonClick = (e: any, tag: number) => {
        console.log(tag);
        const now = new Date();
        let startDate: Date | undefined
        let endDate: Date | undefined
        let period: TimePeriod = TimePeriod.AllTime

        switch (tag) {
            case TimePeriod.AllTime:
                break;
            case TimePeriod.Today:
                startDate = now;
                startDate.setHours(0, 0, 0);
                endDate = new Date(now)
                endDate.setHours(23, 59, 59, 999);
                period = TimePeriod.Today
                break;
            case TimePeriod.ThisWeek:
                startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay())
                endDate = now
                period = TimePeriod.ThisWeek
                break;
            case TimePeriod.ThisMonth:
                startDate = new Date(now.getFullYear(), now.getMonth(), 1)
                endDate = now
                period = TimePeriod.ThisMonth
                break;
            case TimePeriod.Fortnight:
                startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() - 7)
                endDate = now
                period = TimePeriod.Fortnight
                break;
        }

        this.props.reportChangeFilterAction!({ startDate, endDate, searchString: undefined, timePeriod: period })
    }
}

const mapStateToProps = (state: IRootState) => ({
    selectedTag: state.reports.filters!.timePeriod
});

export default connect(
    mapStateToProps,
    { reportChangeFilterAction }
)(injectIntl(CreationDateGroup));



// WEBPACK FOOTER //
// ./src/components/report-sidebar-filters/creation-date-group.tsx